import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default { init, useList, createDir, fetch };

let g_mediaListMap: any = new Map<string, any[]>();
let g_extraDirListMap: any = new Map<string, any[]>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function init(done) {
  done?.();
}
function _getList(media_grant_id: number, path: string) {
  const key = `${media_grant_id}-${path}`;
  return g_mediaListMap.get(key);
}
export function useList(media_grant_id: number, path: string) {
  const _get = React.useCallback(
    () => _getList(media_grant_id, path),
    [media_grant_id, path]
  );
  return React.useSyncExternalStore(_subscribe, _get);
}
function createDir(params: any) {
  const { media_grant_id, path, new_dir } = params;
  const key = `${media_grant_id}-${path}`;
  let old = g_mediaListMap[key];
  const dir_list = old?.dir_list;
  const dir_name = path + new_dir;
  const dir_lc = dir_name.toLowerCase();

  if (!dir_list?.find?.((d) => d.dir_name.toLowerCase() === dir_lc)) {
    if (!g_extraDirListMap.has(key)) {
      g_extraDirListMap.set(key, []);
    }
    const extra_list = g_extraDirListMap.get(key);
    if (!extra_list.find((name) => name === dir_lc)) {
      extra_list.push(dir_name);
    }
    if (!old) {
      old = { media_list: [], dir_list: [] };
    }
    if (!old.dir_list) {
      old.dir_list = [];
    }
    old.dir_list.push({ dir_name, file_count: 1 });
    g_mediaListMap.set(key, util.deepClone(old));
    _emit('new_dir');
  }
}
function _addExtraDirs(key, body) {
  const extra_list = g_extraDirListMap[key];
  extra_list?.forEach?.((dir_name) => {
    const dir_lc = dir_name.toLowerCase();
    if (!body.dir_list.find((d) => d.dir_name.toLowerCase() === dir_lc)) {
      body.dir_list.push({ dir_name, file_count: 1 });
    }
  });
}
function fetch(params: any, done?: any) {
  const { org_id, media_grant_id, path } = params;
  const opts = {
    url: `/web/1/org/${org_id}/media_grant/${media_grant_id}/dir`,
    query: { media_grant_id, prefix_path: path },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DirStore.fetch: err:', err, body, opts);
    } else {
      const key = `${media_grant_id}-${path}`;
      _addExtraDirs(key, body);
      const old = g_mediaListMap.get(key);
      if (!util.deepEqual(old, body)) {
        g_mediaListMap.set(key, body);
        _emit('update_dir');
      }
    }
    done?.(err, body);
  });
}
